module.exports = "/images/rating-image.png?8fa435d6567bd6c3ccb4af2231d23544";